import React from 'react'

import { useSelector } from 'react-redux'

import { useIsOptimizelyFeatureEnabled } from 'containers/OptimizelyRollouts'
import { useBasket } from 'routes/Menu/domains/basket'
import {
  getDeliveryDetailsInstructions,
  getIsValidDeliveryDetailsInstructionsCustom,
} from 'selectors/deliveryDetails'

import { DeliverySlot } from './DeliverySlot'

const DeliverySlotWrapper = (ownProps: any) => {
  const { removeRecipe } = useBasket()
  const isMoveDeliveryInstructionEnabled = useIsOptimizelyFeatureEnabled(
    'beetroots_move_delivery_instructions_form_web_enabled_v3',
  )

  const deliveryInstruction = useSelector(getDeliveryDetailsInstructions)
  const isValidDeliveryDetailsInstructionCustom = useSelector(
    getIsValidDeliveryDetailsInstructionsCustom,
  )

  return (
    <DeliverySlot
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...ownProps}
      removeRecipeFromBasket={removeRecipe}
      isMoveDeliveryInstructionEnabled={isMoveDeliveryInstructionEnabled}
      deliveryInstruction={deliveryInstruction}
      isValidDeliveryDetailsInstructionCustom={isValidDeliveryDetailsInstructionCustom}
    />
  )
}

export { DeliverySlotWrapper }
